// extracted by mini-css-extract-plugin
export default {"newSlotContainer":"NewSlot_newSlotContainer__tyZcx","slotElements":"NewSlot_slotElements__MB+A5","delete":"NewSlot_delete__QzRf6"};